export default "__VITE_ASSET__BOJyd7v4__"